import React, { useEffect, useRef, useState } from 'react';
import { Shield, Target } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const Standards = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-600 text-sm font-semibold uppercase tracking-wider">{t('standards.badge')}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mt-4">{t('standards.title')}</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <div className={`group relative bg-neutral-50 rounded-3xl p-8 md:p-10 border border-neutral-100 hover:border-red-200 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-6 group-hover:bg-red-100 transition-colors">
              <Shield className="text-red-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-neutral-900 mb-4">{t('standards.standard1.title')}</h3>
            <p className="text-neutral-600 leading-relaxed mb-6">{t('standards.standard1.description')}</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-neutral-700"><div className="w-2 h-2 rounded-full bg-red-500" />{t('standards.standard1.feature1')}</li>
              <li className="flex items-center gap-3 text-neutral-700"><div className="w-2 h-2 rounded-full bg-red-500" />{t('standards.standard1.feature2')}</li>
              <li className="flex items-center gap-3 text-neutral-700"><div className="w-2 h-2 rounded-full bg-red-500" />{t('standards.standard1.feature3')}</li>
            </ul>
          </div>

          <div className={`group relative bg-neutral-50 rounded-3xl p-8 md:p-10 border border-neutral-100 hover:border-red-200 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{transitionDelay: '200ms'}}>
            <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-6 group-hover:bg-red-100 transition-colors">
              <Target className="text-red-600" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-neutral-900 mb-4">{t('standards.standard2.title')}</h3>
            <p className="text-neutral-600 leading-relaxed mb-6">{t('standards.standard2.description')}</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-neutral-700"><div className="w-2 h-2 rounded-full bg-red-500" />{t('standards.standard2.feature1')}</li>
              <li className="flex items-center gap-3 text-neutral-700"><div className="w-2 h-2 rounded-full bg-red-500" />{t('standards.standard2.feature2')}</li>
              <li className="flex items-center gap-3 text-neutral-700"><div className="w-2 h-2 rounded-full bg-red-500" />{t('standards.standard2.feature3')}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Standards;
